import { useSelector } from "react-redux";

import { useGetCompanyRevenuesQuery } from "@/pages/Private/redux/company-revenue/company-revenue.api";
import { useGetCompanySizesQuery } from "@/pages/Private/redux/company-size/company-size.api";
import { useGetIndustriesQuery } from "@/pages/Private/redux/industry/industry.api";
import { industrySelector } from "@/pages/Private/redux/industry/industry.slice";
import { companySizeSelector } from "@/pages/Private/redux/company-size/company-size.slice";
import { companyRevenueSelector } from "@/pages/Private/redux/company-revenue/company-revenue.slice";
import { useGetCompanyBalancesQuery } from "@/pages/Private/redux/company-balance/company-balance.api";
import { companyBalanceSelector } from "@/pages/Private/redux/company-balance/company-balance.slice";

export function useBusinessQuestionnaireOptions() {
	const { isLoading: isLoadingIndustries } = useGetIndustriesQuery();
	const { isLoading: isLoadingCompanySizes } = useGetCompanySizesQuery();
	const { isLoading: isLoadingCompanyRevenues } = useGetCompanyRevenuesQuery();
	const { isLoading: isLoadingCompanyBalances } = useGetCompanyBalancesQuery();

	const industries = useSelector(industrySelector);
	const companySizes = useSelector(companySizeSelector);
	const companyRevenues = useSelector(companyRevenueSelector);
	const companyBalances = useSelector(companyBalanceSelector);

	const isLoading =
		isLoadingIndustries ||
		isLoadingCompanySizes ||
		isLoadingCompanyRevenues ||
		isLoadingCompanyBalances;

	return {
		industries,
		companySizes,
		companyRevenues,
		companyBalances,
		isLoading,
	};
}
